export const environment = {
  production: true,
  apiURL : "https://bisweb.yisd.net/AttendanceMeterDetail_api/",
  ssoRedirectURL: 'https://bisweb.yisd.net/AttendanceMeterDetail/',
};
